<div class="overlay" *ngIf="isOpen && announcement">
	<div class="dialog" [ngStyle]="{ 'width': isMobile ? '340px' : '600px' }">
		<div class="dialog-header border-bottom">
			<h4 class="ms-3">Announcement</h4>
		</div>

		<div class="dialog-body ms-4 me-3">
			<div class="announcement-content" [innerHTML]="safeHtml"></div>
		</div>

		<div class="dialog-footer border-top">
			<button style="width:100px" class="btn btn-outline-primary mt-2" (click)="close()">OK</button>
		</div>
	</div>
</div>
